import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const IdealLogo = React.memo((props: Props) => {
  const {
    width = 26,
    height = 23,
    className,
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox='0 0 26 23'
    >
      <g id='logo-/-payment-/-ideal' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='ideal' fillRule='nonzero'>
          <path d='M0.0890525357,0.0907986638 L0.0890525357,22.7475099 L13.2981628,22.7475099 C22.0116915,22.7475099 25.7903128,17.8677801 25.7903128,11.3969784 C25.7903128,4.95132098 22.0116915,0.0907986638 13.2981628,0.0907986638 L0.0890525357,0.0907986638 Z' id='Path' fill='#FFFFFF'></path>
          <path d='M1.51668691,1.51982994 L13.2999089,1.51982994 C21.2975251,1.51982994 24.3630276,5.88724567 24.3630276,11.3966292 C24.3630276,18.0029305 20.0822199,21.3177801 13.2999089,21.3177801 L1.51668691,21.3177801 L1.51668691,1.51982994 Z M2.65900395,2.66214698 L2.65900395,20.1761616 L13.2999089,20.1761616 C19.7242636,20.1761616 23.2196629,17.1825995 23.2196629,11.3966292 C23.2196629,5.45036441 19.4305648,2.66179775 13.2999089,2.66179775 L2.65900395,2.66179775 L2.65900395,2.66214698 Z' id='Shape' fill='#000000'></path>
          <polygon id='Path' fill='#000000' points='4.08663832 12.6845733 7.49298512 12.6845733 7.49298512 18.7471303 4.08663832 18.7471303'></polygon>
          <circle id='Oval' fill='#000000' cx='5.7894625' cy='9.62989675' r='2.11700577'></circle>
          <path d='M14.6363954,10.6203006 L14.6363954,11.6019739 L12.2092773,11.6019739 L12.2092773,7.66270878 L14.5588673,7.66270878 L14.5588673,8.6440328 L13.1906013,8.6440328 L13.1906013,9.10012147 L14.4844822,9.10012147 L14.4844822,10.0817947 L13.1906013,10.0817947 L13.1906013,10.6206499 L14.6363954,10.6203006 Z M15.0610538,11.6026723 L16.2487701,7.66131187 L17.6449742,7.66131187 L18.8323413,11.6026723 L17.8108564,11.6026723 L17.5880504,10.8403128 L16.304297,10.8403128 L16.0811418,11.6026723 L15.0610538,11.6026723 L15.0610538,11.6026723 Z M16.5920589,9.85968722 L17.3023838,9.85968722 L16.9765563,8.74635591 L16.917188,8.74635591 L16.5920589,9.85968722 Z M19.3257971,7.6616611 L20.3078196,7.6616611 L20.3078196,10.6206499 L21.7612967,10.6206499 C21.362481,5.25165503 17.1396447,4.09152748 13.3002581,4.09152748 L9.20838142,4.09152748 L9.20838142,7.66375645 L9.81393866,7.66375645 C10.9181901,7.66375645 11.60372,8.4124962 11.60372,9.61732463 C11.60372,10.8605679 10.9346037,11.6026723 9.81393866,11.6026723 L9.20838142,11.6026723 L9.20838142,18.7499241 L13.3006073,18.7499241 C19.5398725,18.7499241 21.7127543,15.8520498 21.789584,11.6019739 L19.3257971,11.6019739 L19.3257971,7.6616611 L19.3257971,7.6616611 Z M9.20768296,8.64508047 L9.20768296,10.6206499 L9.81393866,10.6206499 C10.2340571,10.6206499 10.622396,10.4991193 10.622396,9.6169754 C10.622396,8.75543577 10.1904039,8.64508047 9.81393866,8.64508047 L9.20768296,8.64508047 L9.20768296,8.64508047 Z' id='Shape' fill='#D50072'></path>
        </g>
      </g>
    </svg>
  );
});

IdealLogo.displayName = 'IdealLogo';
